import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the FcmProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class FcmProvider {

  constructor(public http: HttpClient) {
    console.log('Hello FcmProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/fcm/fcm.ts